import { ChipData, ListDataRow } from "types/list";

export function sortAccordingToOrder(a: string, b: string, order: string[]) {
  const orderA = order.includes(a) ? order.indexOf(a) : Infinity;
  const orderB = order.includes(b) ? order.indexOf(b) : Infinity;
  return orderA - orderB;
}

export function sortAccordingToDateStr(a: string, b: string) {
  const dateA = new Date(a);
  const dateB = new Date(b);

  return dateA.getTime() - dateB.getTime();
}

export function sortAlphabetically(a: string, b: string, languageCode?: string) {
  let lang = "da-DK";
  if (languageCode) lang = languageCode;
  const valueA = typeof a === "string" ? a : "";
  const valueB = typeof b === "string" ? b : "";
  return valueA.localeCompare(valueB, lang);
}

export function sortNumAlpha(a: string, b: string) {
  const [numA, alphaA] = splitNumAlpha(a);
  const [numB, alphaB] = splitNumAlpha(b);

  if (numA !== numB) {
    return numA - numB;
  } else {
    const valueA = typeof alphaA === "string" ? alphaA : "";
    const valueB = typeof alphaB === "string" ? alphaB : "";
    return valueA.localeCompare(valueB);
  }
}

function splitNumAlpha(text: string): [number, string] {
  const matches = text.match(/^(\d+)([a-zA-ZæøåÆØÅ]*)$/);
  if (matches) {
    return [parseInt(matches[1]), matches[2]];
  } else {
    // Handle non-standard entries like 'test' by giving them a high arbitrary number
    return [Infinity, text];
  }
}

export function sortAccordingToCurrentUserAndAdmin(a: ListDataRow, b: ListDataRow) {
  // Sort according to current user
  if (a.currentUser) return -1;
  if (b.currentUser) return 1;
  // Sort according to admin
  if (a.isAdmin === undefined || b.isAdmin === undefined) return 0;
  if (a.isAdmin && !b.isAdmin) {
    return -1; // a comes before b
  } else if (!a.isAdmin && b.isAdmin) {
    return 1; // b comes before a
  }
  return 0; // no change in order
}

export function sortAccordingToEstate(a: ChipData, b: ChipData) {
  let estateA = a.label.split("\n")[1] ? a.label.split("\n")[1] : "";
  let estateB = b.label.split("\n")[1] ? b.label.split("\n")[1] : "";
  estateA = typeof estateA === "string" ? estateA : "";
  estateB = typeof estateB === "string" ? estateB : "";
  return estateA.localeCompare(estateB);
}

export function sortAccordingToInOrg(a: ChipData, b: ChipData) {
  if (a.inOrg && !b.inOrg) return -1;
  if (b.inOrg && !a.inOrg) return 1;
  return 0;
}